import React from "react"
import styled, { css } from 'styled-components'

import Container from '../../shared/Container'
import LinkButton from '../../shared/Buttons/LinkButton'
import Socials from '../../shared/Socials'

const StyledFooter = styled.footer`
  ${({ theme: { color } }) => css`
    background: ${color.bg}
  `}
`

const Inner = styled.div`
  ${({ theme: { color } }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    border-top: solid 1px ${color.grey};
  `}
`

const Text = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  line-height: 2.0;
  span {
    display: inline-block;
  }
  a {
    font-size: 1.2rem;
  }
`

const Copyright = styled.p`
  ${({ theme: { color } }) => css`
    color: ${color.grey};
  `}
  text-align: center;
  padding: 2.4rem 0;
  font-size: 1.0rem;
  span {
    display: inline-block;
  }
`

const SocialFrame = styled.div`
  padding: 4.0rem 0;
`

const Footer = () => (
  <StyledFooter>
    <Container>
      <Inner>
        <SocialFrame>
          <Socials />
        </SocialFrame>
        <Text>主催：<span>多摩美術大学 情報デザイン学科情報デザインコース</span> <span>卒業研究制作展 2021 実行委員会</span></Text>
        <Text>お問い合わせ：<LinkButton href={"http://www.idd.tamabi.ac.jp/design/"}>情報デザイン学科情報デザインコース研究室</LinkButton></Text>
        <Copyright>©︎ 2021 Tama Art University Department of <span>Information design Interaction Design Course</span></Copyright>
      </Inner>
    </Container>
  </StyledFooter>
)

export default Footer